export const MOBILE_HEADER_HEIGHT = 60
export const DESKTOP_HEADER_HEIGHT = 83
